
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export async function createStudentUser(email: string, password: string) {
  try {
    // Step 1: Sign up the user with Supabase Auth
    const { data: authData, error: authError } = await supabase.auth.signUp({
      email,
      password,
    });

    if (authError) {
      throw new Error(`Authentication error: ${authError.message}`);
    }

    if (!authData.user) {
      throw new Error('User creation failed: No user returned');
    }

    // Step 2: Assign student role to the user
    const { error: roleError } = await supabase
      .from('user_roles')
      .insert({
        user_id: authData.user.id,
        role: 'student'
      });

    if (roleError) {
      throw new Error(`Role assignment error: ${roleError.message}`);
    }

    // Step 3: Verify user creation
    const { data: userData, error: verifyError } = await supabase
      .from('user_profiles')
      .select('*')
      .eq('id', authData.user.id)
      .single();

    if (verifyError) {
      throw new Error(`Verification error: ${verifyError.message}`);
    }

    console.log('Student user created successfully:', {
      user_id: authData.user.id,
      email: authData.user.email,
      profile: userData
    });

    return {
      user: authData.user,
      profile: userData
    };
  } catch (error) {
    console.error('Error creating student user:', error);
    throw error;
  }
}
